import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const SideContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${({ isMobile }) => (isMobile ? 0.5 : 1)};
  width: 284px;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.mocaPurple};
  position: ${({ isMobile }) => (isMobile ? 'absolute' : 'relative')};
  margin-left: ${({ isShown }) => (isShown ? '0' : '-284px')};
  transition: margin .5s;
  z-index: 9998;
`

export const StyledNavLink = styled(NavLink)`
  color: ${({ theme }) => theme.white};
  font-size: ${({ size }) => size ? size : '16px'};
  height: 64px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-left: 8px solid transparent;

  &:hover {
    background-color: ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.2000790550595238)};
    color: ${({ theme }) => theme.white};
    text-decoration: none;
  }

  &.active {
    background-color: ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.2000790550595238)};
    color: ${({ theme }) => theme.white};
    text-decoration: none;
    border-left: 8px solid ${({ theme }) => theme.mocaOrange};
    font-weight: bold;
  }
`

export const NavWithChildren = styled.div`
  &:hover > div {
    background-color: ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.2000790550595238)};
    color: ${({ theme }) => theme.white};
    cursor: pointer;
    text-decoration: none;
  }

  > div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: ${({ theme }) => theme.white};
    font-size: ${({ size }) => size ? size : '16px'};
    height: 64px;
    border-left: 8px solid transparent;

    &.active {
      background-color: ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.2000790550595238)};
      color: ${({ theme }) => theme.white};
      text-decoration: none;
      border-left: 8px solid ${({ theme }) => theme.mocaOrange};
      font-weight: bold;
    }
  }
`

export const Children = styled.nav`
  display: ${({ expanded }) => expanded ? 'block' : 'none'};

  &.active + & {
    display: block;
  }
`

export const NavChild = styled(NavLink)`
  color: ${({ theme }) => theme.white};
  font-size: ${({ size }) => size ? size : '16px'};
  height: 56px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 4px 24px;
  border-radius: 8px;

  &:hover,
  &.active {
    background-color: ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.2000790550595238)};
    color: ${({ theme }) => theme.white};
    text-decoration: none;
  }
`

export const LogoContainer = styled.div`
  height: 184px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
